import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { enableDisableProposalAction } from "../../store/actions/proposalActions";
import { uploadBulkDisable } from "../../store/actions/fileUploadActions";
import DataTable from "../../components/Table";
import { toaster } from "../../utils/utils";

const NewDisableProposal = () => {
  const [proposalNumber, setProposalNumber] = useState("");
  const [disableData, setDisableData] = useState("");
  const dispatch = useDispatch();

  const triggerUploadCSV = () => {
    document.getElementById("disable-csv-upload").click();
  };

  const disableProposal = useCallback(() => {
    const disable = true;
    dispatch(
      enableDisableProposalAction(proposalNumber, disable, (data) => {
        const { body } = data;
        if (body) {
          const disableResult = [body];
          setDisableData(disableResult);
        }
      })
    );
  }, [proposalNumber, dispatch]);

  const disableAllProposal = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("disableProposal", true);
    dispatch(
      uploadBulkDisable(formData, (data) => {
        const {
          data: { body },
        } = data;
        if (body) {
          setDisableData(body);
        }
      })
    );
  };

  return (
    <>
      <div className="disable-enable-proposal-page__panel disable-enable-proposal-page__panel--compact">
        <div className="disable-enable-proposal-page__controls-row">
          <button
            type="button"
            className="disable-enable-proposal-page__btn disable-enable-proposal-page__btn--primary"
            onClick={triggerUploadCSV}
          >
            Upload All
          </button>
          <input
            id="disable-csv-upload"
            className="disable-enable-proposal-page__file-input"
            type="file"
            name="file"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={(e) => {
              if (
                e.target.files &&
                e.target.files.length &&
                e.target.files[0].size / 1000 / 1000 > 10
              ) {
                return toaster(
                  "warn",
                  "Selected file size cannot be greater than 10 mb."
                );
              }
              if (e.target.files && e.target.files.length) {
                disableAllProposal(e.target.files[0]);
              }
            }}
          />
        </div>
      </div>

      {disableData && (
        <div className="proposal-dashboard__table-section disable-enable-proposal-page__table-section">
          <DataTable
            cellHeaders={["Proposal Number", "Remarks", "Disbaled Status"]}
            data={disableData}
            keys={["proposalNumber", "remarks", "disbaledStatus"]}
            fileName="disable"
            addSerialNo={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={disableData}
            alwaysShown={false}
            convertValueToString={true}
          />
        </div>
      )}
    </>
  );
};

export default NewDisableProposal;
